export enum CSSVariables {
  PrimaryColor = '--primary-color',
  PrimaryColorLight = '--primary-light',
  PrimaryColorLighter = '--primary-lighter',
}
